import { getCurrentLocale } from '@probatix/common/translations'
import { createApi } from '@reduxjs/toolkit/query/react'

import { request, gql } from 'graphql-request'

const STOREFRONT_PUBLIC_TOKEN = 'e5fccf6c0984a0ff5a424015a4b44311'

export const graphqlBaseQuery = ({ baseUrl }: { baseUrl: string }) => async (
  { body }: { body: string }) => {
  try {
    const headers = {
      'Accept-Language': getCurrentLocale().code.slice(0, 2),
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_PUBLIC_TOKEN,
    }

    const result = await request(baseUrl, body, undefined, headers)

    return { data: result }
  } catch (error: any) {

    if (error.response && error.response.status) {
      return { error: { data: error, status: error.response.status } }
    }

    return {
      error: {
        data: error,
        status: error?.response?.status || 500,
      },
    }
  }
}

export const graphQLApi = createApi({
  baseQuery: graphqlBaseQuery({
    baseUrl: 'https://probatix.de/api/2025-01/graphql.json',
  }),
  endpoints: (builder) => ({
    getBiomarkerList: builder.query({
      query: ({ ids }) => ({
        body: gql`
          query {
            nodes(ids: ${ids}) {
                ... on Metaobject {
                    id
                    fields {
                        key
                        value
                    }
                }
            }
        }`,
      }),
    }),
    getTag: builder.query({
      query: ({ ids }) => ({
        body: gql`
          query {
            nodes(ids: "${ids}") {
                ... on Metaobject {
                    id
                    fields {
                        key
                        value
                    }
                }
            }
        }`,
      }),
    }),
    getTags: builder.query({
      query: () => ({
        body: gql`
            query {
              metaobjects(type: "biomarker_tag", first: 20) {
                  edges {
                    node {
                      id
                      fields {
                        key
                        value
                      }
                    }
                  }
              }
          }`,
      }),
    }),
  }),
  reducerPath: 'graphQLApi',
})

export const useGetTagsGraphQL = graphQLApi.endpoints.getTags.useLazyQuery
export const useGetBiomarkersGraphQL = graphQLApi.endpoints.getBiomarkerList.useLazyQuery
export const useGetGraphQL = graphQLApi.endpoints.getTag.useLazyQuery
